import {Component, OnInit} from '@angular/core';
import {AuthService} from "@hassel-it/angular-common";
import {TimeagoIntl} from "ngx-timeago";
import {ActivatedRoute, Router} from "@angular/router";
import {environment} from '../../environments/environment';
import {PermissionsService} from "../permissions.service";

@Component({
    selector: 'app-main-navigation',
    templateUrl: './main-navigation.component.html',
    styleUrls: ['./main-navigation.component.scss']
})
export class MainNavigationComponent implements OnInit {
    environment: any;
    isNavbarCollapsed: boolean;

    constructor(public authService: AuthService, intl: TimeagoIntl, public activatedRoute: ActivatedRoute, public permissionsService: PermissionsService,
                private router: Router

    ) {
        this.environment = environment;
    }

    ngOnInit(): void {
        this.permissionsService.buildPermissions();
    }

    logout() {
        this.authService.logout('/', true).subscribe((d) => {
            //this.router.navigateByUrl('/');
            window.location.reload();
        });
    }
}
